import { Button, FormControl, Grid, MenuItem, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Formik } from "formik";
import React from "react";
import SelectDays from "../../../../components/SelectDays";
import SelectDropOtions from "../../../../components/SelectDropOtions";
import { useStyleFormAssignDoc, validateSchemaFormAssignDoc } from "../helpers/assignDoctorOption";

export default function FormAssignDoc({ onSubmit, handleCancel, doctorDetail, initialValueFormDoc }) {
    const classes = useStyleFormAssignDoc();
    return (
        <Formik initialValues={initialValueFormDoc} validationSchema={validateSchemaFormAssignDoc} onSubmit={onSubmit}>
            {({ values, setFieldValue, handleChange, errors, handleSubmit }) => (
                <Grid container spacing={2} className="px-5">
                    <Grid item xs={12} sm={4}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={4}>
                                <label className="mb-0">ระบุรายชื่อแพทย์:</label>
                            </Grid>
                            <Grid item xs={8}>
                                <FormControl fullWidth className={`${classes.autoComplete}`}>
                                    <Autocomplete
                                        options={doctorDetail}
                                        value={
                                            values?.codeDoc
                                                ? doctorDetail?.filter(row => row.Doctorcode === values?.codeDoc)[0]
                                                : null
                                        }
                                        getOptionLabel={option => option?.Doctorname}
                                        onChange={(evt, value) => {
                                            setFieldValue("codeDoc", value?.Doctorcode);
                                        }}
                                        size="medium"
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                error={Boolean(errors?.codeDoc)}
                                                helperText={errors?.codeDoc}
                                                variant="outlined"
                                                size="small"
                                                margin="none"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={4}>
                                <label className="mb-0">ระบุวัน:</label>
                            </Grid>
                            <Grid item xs={8}>
                                <SelectDays
                                    containerClass={`${classes.border} ${classes.select}`}
                                    value={values?.days}
                                    name="days"
                                    error={Boolean(errors?.days)}
                                    helperText={errors?.days}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={4}>
                                <label className="mb-0">ช่วงเวลา:</label>
                            </Grid>
                            <Grid item xs={8}>
                                <SelectDropOtions
                                    containerClass={`${classes.border} ${classes.select}`}
                                    options={[
                                        { title: "ช่วงเช้า", value: "0" },
                                        { title: "ช่วงบ่าย", value: "1" },
                                        { title: "ช่วงค่ำ", value: "2" },
                                    ]}
                                    placeholder="Select Moment..."
                                    value={values?.period}
                                    onChange={value => setFieldValue("period", value)}
                                    error={Boolean(errors?.period)}
                                    helperText={errors?.period}
                                    renderOption={row => (
                                        <MenuItem value={row?.value} key={row?.value + "_b"}>
                                            {row?.title}
                                        </MenuItem>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* actions */}
                    <Grid item xs={12} className="mt-10">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-11 col-sm-6 col-xl-6">
                                <div className="row justify-content-center">
                                    <div className="col-6 col-md-4 col-lg-2 mr-2">
                                        <Button className="t-btn-primary w-100" onClick={handleSubmit}>
                                            Save
                                        </Button>
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2" onClick={handleCancel}>
                                        <Button className="t-btn-gray w-100">Cancel</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            )}
        </Formik>
    );
}
